module.exports = __webpack_public_path__ + "img/scavenge-exhaust-schematic-light.9f6c4a6e.png";